<template>
  <div class="attendee">
    <van-tabs v-model="active" @click="onClick">
      <van-tab title="已接受"></van-tab>
      <van-tab title="未响应"></van-tab>
      <van-tab title="已拒绝"></van-tab>
    </van-tabs>
    <div>
      <div class="userInfo" v-for="(item,index) in listData" :key="index">
        <img class="avatar" :src="item.userHeadImage||user_default" alt="" />
        <div class="name-box">
          <span class="name">{{item.userName}}</span>
          <span class="companyname">{{item.userCorporateName}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import user_default from '@/assets/user_default.png'
export default {
  name: "",

  data() {
    return {
      active: 0,
      loading: false,
      finished: false,
      listData:[],
      user_default:user_default
    };
  },
  mounted() {
    console.log(this.user_default)
    this.meetingList(this.active);
  },
  methods: {
    onLoad() {
      fetchSomeThing().catch(() => {
        this.error = true;
      });
    },
    onClick(index) {
      this.meetingList(index);
    },
    meetingList(index) {
      var params = {
        meetingId: Number(this.$route.query.id),
        exhibitionId: this.$route.query.exhibitionId,
        acceptedStatus: index,
        auditStatus: "APPROVE",
      };
      if (index > 0) {
        delete params.auditStatus;
      }
      this.$http.meetingList(params).then((res) => {
        console.log(res, "11");
        this.listData = res.data.list
      });
    },
  },
};
</script>

<style lang="scss" >
.van-tab {
  padding: 0;
}
.van-tabs__nav {
  height: 45px;
}
.van-tabs__line {
  width: 150px;
  height: 2px;
  background: #ae2137;
}
.van-tab {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #c7c7c7;
  line-height: 25px;
  width: 125px;
}
.van-tab--active {
  font-size: 18px !important;
  color: #ae2137 !important;
}
</style>
<style lang="scss" scoped>
.userInfo {
  display: flex;
  padding: 24px 15px;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #f5f6fa;
  .avatar {
    width: 50px;
    height: 50px;
    border: 2px solid #ffb133;
    margin-right: 15px;
    border-radius: 50%;
    overflow: hidden;
  }
  .name-box {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    .name {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #140f26;
      line-height: 18px;
      margin-bottom: 8px;
    }
    .companyname {
      font-size: 13px;
      font-family: PingFangSC-Light, PingFang SC;
      color: #6e7580;
      line-height: 19px;
    }
  }
}
.userInfo:last-child() {
  border: none;
}
</style>
